import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { store } from './store';
import { hydrateCart } from './features/products/productsSlice';
import { registerServiceWorker } from './serviceWorkerRegistration';

const STORAGE_KEY = "fresh-market-cart";

try {
  const persistedCart = window.localStorage.getItem(STORAGE_KEY);
  if (persistedCart) {
    store.dispatch(hydrateCart({ cart: JSON.parse(persistedCart) }));
  }
} catch {
  // Ignore invalid local cart data.
}

store.subscribe(() => {
  try {
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(store.getState().products.cart));
  } catch {
    // Ignore storage failures caused by quota or privacy restrictions.
  }
});

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

registerServiceWorker();
